import { useCallback } from 'react';
import { useCollectionStore } from '@/store/collection';

// Contents default to newest first, independently of the Collections list.
export default function useCollectionContentSort(collectionId, contentType) {
  const sortOrder = useCollectionStore(state => (
    state.contentSortOrders[collectionId]?.[contentType] ?? 'newest'
  ));
  const setContentSortOrder = useCollectionStore(state => state.setContentSortOrder);
  const setSortOrder = useCallback((order) => {
    setContentSortOrder(collectionId, contentType, order);
  }, [collectionId, contentType, setContentSortOrder]);

  return [sortOrder, setSortOrder];
}
